import React from "react";
import SetTable from "../sets/SetTable";
import { Button } from "reactstrap";
import WorkoutApi from "../Api";
import { useNavigate } from "react-router-dom";
import SetForm from "../sets/SetsForm";
import "../exerciseCard.css";

const ExerciseCard = ({ date, name, description, e_id, w_id }) => {
  const navigate = useNavigate();
  const deleteExercise = () => {
    WorkoutApi.deleteExercise(e_id).then((res) => console.log(res));
    navigate("/");
  };

  return (
    <>
      <div className="exercise-block">
        <h5 className="bebas-neue">Exercise : {name}</h5>
        <h5 className="bebas-neue">Focus : {description}</h5>

        <small className="text-muted bebas-neue">Date: {date}</small>
        <a href={`/exercise/${e_id}/edit`}>
          <Button className="buttonspace bebas-neue" color="primary">
            Edit Exercise
          </Button>
        </a>

        <Button
          className="buttonspace bebas-neue"
          color="primary"
          onClick={deleteExercise}
        >
          Delete Exercise
        </Button>
      </div>
      <SetForm e_id={e_id} />
      <SetTable e_id={e_id} />
    </>
  );
};

export default ExerciseCard;
